<template>
  <div>
    <header-ton></header-ton>
    <div class="head-logo">
      <h1 class="logo-box">
        <a href="javascript:;" class="logo">结算中心</a>
        <ul class="process">
          <li class="this"><i class="number">1</i><i class="text">确认订单</i><b class="line"></b></li>
          <li class="this"><i class="number">2</i><i class="text">支付订单</i><b class="line"></b></li>
          <li><i class="number">3</i><i class="text">订单完成</i></li>
        </ul>
      </h1>
    </div>

    <div class="car-box">
      <div class="content1 pay" style="width: 1200px;">
        <div class="order-success">
          <div class="grey-bg"></div>
          <div class="f-fl"><i class="ico"></i><em><strong class="green f-f14">订单提交成功</strong><br>
              请在48小时内完成支付，逾期优惠券将失效！</em>
          </div>
          <div class="f-fr">
            应付金额：<font class="red"><strong class="f-f24">{{infoData.amount}}</strong>
              <font class="f-f12">元</font>
            </font><br>
          </div>
          <div class="pay-open" style="display: block;">
            <h4><i class="left"></i><i class="text">商品名称</i><i class="right"></i></h4>
            <ul class="list" style="border-right: 1px solid rgb(241, 241, 241);">
              <li><i class="grey">课程</i><i>{{infoData.title}}</i></li>
              <li><i class="grey">科目</i><i>{{infoData.attr_name}}</i></li>
            </ul>
            <ul class="list right">
              <li><i class="grey">收&nbsp;&nbsp;货&nbsp;&nbsp;人</i><i>{{address.truename}}</i></li>
              <li><i class="grey">联系电话</i><i>{{address.phone}}</i></li>
              <li><i class="grey">收货地址</i><i>{{address.address}}</i></li>
            </ul>
          </div>
        </div>
        <div id="cbpay" class="order-box" style="display: block;">
          <div class="order-boxone">
            <ul class="pay-nav">
              <li>
                <i>付款方式：</i>
                <a href="javascript:;" class="this">支付平台</a>
              </li>
            </ul>
            <ul class="order-bank">
              <li>
                <a href="javascript:;" id="pay_wx" @click="buyWechat()"><i class="ico wx"></i><b class="xz"></b></a>
                <a href="javascript:;" id="pay_zfb" style="display: none;">
                  <i class="ico zfb"></i><i class="text">帐号：examda@gmail.com</i><b class="xz"></b>
                  <form target="_blank" method="post" action="https://www.jianjiangedu.cn/alipay/alipaysend" name="formbill_zfb" id="formbill_zfb">
                    <input type="hidden" name="_token" value="VxQzetfj9h6e8qd9Xk6hAmnboBTQjWdyOy8Os2TM">
                    <input type="hidden" value="240802594421748" name="OrdersID">
                  </form>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="order-question" style="display: block;">
          <h4>付款常见问题</h4>
          <ul>
            <li>如您无法使用在线支付，可联系客服选择汇款支付。<i>1</i></li>
            <li>如果您购买的事虚拟物品，暂不支持申请退款，介意者勿拍！<i>2</i></li>
            <li>购课提示：您在报名过程中有任何疑问，请拨打<font class="red">400-150-5166</font>
              （免长途费）<i>3</i></li>
            <!-- <li><a href="https://www.jianjiangedu.cn/news" target="_blank" class="bule">更多相关帮助&gt;&gt;</a></li> -->
          </ul>
        </div>
      </div>
    </div>

    <el-dialog title="微信支付" :close-on-click-modal="false" :visible.sync="dialogTableVisible" width="15%" top="26vh" @close="closeWxPay">
      <div class="box_pay">
        <span class="box_title">请使用微信扫码支付</span>
        <div class="box_qrcode">
          <el-image :src="srcQrcode"></el-image>
        </div>
      </div>
    </el-dialog>

    <booter-ton></booter-ton>
  </div>
</template>
<script>
import HeaderTon from "@/components/HeaderTon";
import BooterTon from "@/components/BooterTon";
export default {
  components: {
    HeaderTon,
    BooterTon,
  },
  data() {
    return {
      keywords: "",
      dialogTableVisible: false,
      fullscreenLoading: true,
      idNo: 0,
      srcQrcode: "",
      infoData: [],
      address: [],
    };
  },
  mounted() {
    var that = this;
    var query = that.$route.query;
    if (query.idNo) {
      that.idNo = query.idNo;
      this.getList();
    }
  },
  methods: {
    closeWxPay() {
      this.dialogTableVisible = false;
    },

    isPay() {
      const that = this;
      that.axios
        .post("/payment/get_ispay", {
          order_no: that.idNo,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$router.push({
              path: "/course/index",
            });
          } else {
            that.loading = false;
          }
        });
    },

    getList() {
      let that = this;
      let formData = {};
      formData.idNo = that.idNo;
      that.axios.post("/getOrderDetail", formData).then((res) => {
        if (res) {
          that.infoData = res.data;
          that.address = res.data.address_ary;
        }
      });
    },

    buyWechat() {
      let that = this;
      let formData = {};
      formData.idNo = that.idNo;
      that.axios
        .post("/payment/order_qrcode", {
          idNo: that.idNo,
        })
        .then((res) => {
          if (res.code == 200) {
            that.orderNo = res.data.orderNo;
            that.srcQrcode = res.data.srcQrcode;
            that.dialogTableVisible = true;
            setInterval(function () {
              that.isPay();
            }, 3200);
          } else {
            that.loading = false;
            that.$message.error(res.msg);
          }
        });
    },
  },
};
</script>
<style>
.box_pay {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 230px;
}
.box_title {
  width: 100%;
  line-height: 32px;
  text-align: center;
  height: 32px;
}

.box_qrcode {
  width: 200px;
  height: 200px;
}

.order-question {
  display: block;
  background: #fff;
  padding: 10px;
  margin-top: 10px;
}

@import "../../../public/css/gouwuche.css";
</style>